// extracted by mini-css-extract-plugin
export var form = "emailForm-module--form--f78d9";
export var input = "emailForm-module--input--4bf42";
export var label = "emailForm-module--label--f6d0c";
export var submit = "emailForm-module--submit--feb2e";
export var textarea = "emailForm-module--textarea--b3a3c";
export var wrapper = "emailForm-module--wrapper--8bdce";